import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';

const ProjectGroups = ({ group, activeGroup, scrollHorizontally, selectGroup, messCountGroup }) => {
  const [updatedGroups, setUpdatedGroups] = useState(group);

  // Переупорядочивание списка групп, перенос последнего элемента в начало
  useEffect(() => {
    setUpdatedGroups([group[group.length - 1], ...group.slice(0, -1)]);
  }, [group]);

  // Создаем рефы для хранения ссылок на элементы групп и контейнер
  const groupRefs = useRef([]);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!messCountGroup) return;

    const newCount = messCountGroup.countActiveProject || messCountGroup.сountActiveProject;

    setUpdatedGroups((prevGroups) =>
      messCountGroup.guidGroup === null
        ? prevGroups.map((g) => (g.guid === null ? { ...g, countActiveProject: newCount } : g))
        : prevGroups.map((g) =>
            g.guid === messCountGroup.guidGroup ? { ...g, countActiveProject: newCount } : g,
          ),
    );
  }, [messCountGroup]);

  useLayoutEffect(() => {
    // Прокрутка к активному элементу при загрузке компонента или смене activeGroup
    const activeIndex = updatedGroups.findIndex((c) => c.guid === activeGroup);
    if (activeIndex !== -1 && groupRefs.current[activeIndex] && containerRef.current) {
      const activeElement = groupRefs.current[activeIndex];
      const container = containerRef.current;

      // Вычисление позиции прокрутки для центрирования активного элемента
      const elementLeft = activeElement.offsetLeft;
      const elementWidth = activeElement.offsetWidth;
      const containerWidth = container.offsetWidth;

      const scrollLeft = elementLeft - containerWidth / 2 + elementWidth / 2;

      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth',
      });
    }
  }, [activeGroup, updatedGroups]);

  return (
    <div
      className="project-groups"
      ref={containerRef}
      onWheel={(e) => scrollHorizontally(e)}
      style={{ overflowX: 'auto', display: 'flex' }}>
      {/* Отдельные группы */}
      {updatedGroups.map((c, index) => (
        <div
          key={c.guid || `group-${index}`}
          ref={(el) => (groupRefs.current[index] = el)}
          className={'pr-group-item ' + (activeGroup === c.guid ? 'active' : '')}
          style={c.color?.length > 0 ? { borderColor: c.color } : { borderColor: '#000000' }}
          onClick={(e) => selectGroup(c.guid, e, c.color, index + 1)}>
          {/* Отображение количества активных проектов */}
          <span className="color-circle" style={{ backgroundColor: c.color }}></span>
          <span>{c.name}</span>
          {c.countActiveProject > 0 && (
            <span className="count-indicator">{c.countActiveProject}</span>
          )}
        </div>
      ))}
    </div>
  );
};

export default ProjectGroups;
